<template>
    <b-modal
        id="modal-product-feeds"
        :title="$t('widgeterShops.productFeed')"
        title-class="font-18"
        size="lg"
        hide-footer
        @show="resetData()"
        @hidden="resetData()"
    >
        <b-list-group ref="feedsModalRef">
            <b-list-group-item v-for="(feed, index) in feeds" :key="index" class="feeds">
                <span class="feedUrl">{{ feed }}</span>
                <ButtonIcon
                    class="feed-btn"
                    variant="primary"
                    icon="copy"
                    size="sm"
                    short
                    @click="onCopyFeedUrl(feed)"
                >
                    {{ $t('widgeterShops.copyFeedUrl') }}
                </ButtonIcon>
            </b-list-group-item>
        </b-list-group>
    </b-modal>
</template>



<script>
    export default {
        name: 'ModalProductFeeds',
        data() {
            return {
                feeds: [],
            };
        },
        methods: {
            initFeeds(feeds) {
                this.feeds = feeds;
            },
            resetData() {
                this.feeds = [];
            },
            async onCopyFeedUrl(feed) {
                await this.$copyText(feed, this.$refs.feedsModalRef);
                this.$toastr.success(this.$t('widgeterShops.feedCopied'));
            },
        },
        mounted() {
            this.$root.$on('show-product-feeds', this.initFeeds);
        },
        beforeDestroy() {
            this.$root.$off('show-product-feeds', this.initFeeds);
        },
    };
</script>



<style lang="scss" scoped>
    .feeds {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
    }

    .feedUrl {
        flex-grow: 1;
        margin-right: 10px;
        word-break: break-all;
    }

    .feed-btn {
        white-space: nowrap;
    }
</style>

